import type { SnackBlocksFormModelMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods";
import type { SnackBlocksFormModelSNSMethodsType } from "@/components/features/snack/snack/settings/model/usecase/use-create-snack-layout-settings-form-model/methods/sns";

import { SNSIconsSectionListItem } from "./item";

type Props = {
	snsIcons: SnackBlocksFormModelSNSMethodsType["snsIcons"];

	onSetIsSelectedToSNSIcons: SnackBlocksFormModelMethodsType["SNSMethods"]["onSetIsSelectedToSNSIcons"];
	onSetSNSURLToSnsIcons: SnackBlocksFormModelMethodsType["SNSMethods"]["onSetSNSURLToSnsIcons"];
};

export const SNSIconsSection = ({ snsIcons, onSetIsSelectedToSNSIcons, onSetSNSURLToSnsIcons }: Props) => {
	return (
		<div className="space-y-2">
			<p>SNSアイコンの表示・非表示設定とURL設定</p>

			<div className="ml-4 space-y-2">
				{snsIcons?.value?.map((snsIcon) => {
					return (
						<SNSIconsSectionListItem
							key={snsIcon.snsType.value}
							snsIcon={snsIcon}
							onSetIsSelectedToSNSIcons={onSetIsSelectedToSNSIcons}
							onSetSNSURLToSnsIcons={onSetSNSURLToSnsIcons}
						/>
					);
				})}
			</div>
		</div>
	);
};

SNSIconsSection.displayName = "SNSIconsSection";
